import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ProductStockLogsLayer from "../components/ProductStockLogsLayer";

const ProductStockLogsPage = () => {
    return (
        <MasterLayout>
            <ProductStockLogsLayer />
        </MasterLayout>
    );
};

export default ProductStockLogsPage;
